export const constants = {
    baseUrl: '/'
} 